import styled from 'styled-components/macro';

export const Title = styled.h2`
  color: ${({ theme }) => theme.colors.black_100};

  font-size: ${({ theme }) => theme.fontSize.lg};
  font-family: ${({ theme }) => theme.fontFamily.semiBold};
`;

export const IconWrapper = styled.div`
  font-size: 0;

  cursor: pointer;
`;
